import script from "./ProductImageLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductImageLoader.vue?vue&type=script&setup=true&lang=ts"

import "./ProductImageLoader.vue?vue&type=style&index=0&id=1a1030b1&lang=css"

const __exports__ = script;

export default __exports__